<template>
  <div class="pageHeader">
    <header class="header">
      <a @click="$router.push('/')"><img src="../assets/logo.png" alt="logo" class="logo logoDesktop"></a>
      <a @click="$router.push('/')"><img src="../assets/logo-white.png" alt="logo" class="logo logoMobile"></a>
    </header>
    <stripes class="headerStripes" />
  </div>
</template>
<script>
import Stripes from './Stripes.vue';

export default {
  components: {
    Stripes,
  },
};
</script>
<style lang="scss">
.pageHeader {
  margin: 0 0 30px 0;
}

header.header {
  width: 100%;
  background-color: $kfc-red;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  @include tablet {
    background-color: transparent;
    height: 140px;
  }

  a {
    cursor: pointer;
  }
}

.headerStripes {
  @include tablet {
    display: none !important;
  }
}

.logo {
  max-width: 105px;
  margin: 0;
  padding: 0;
  @include tablet {
    max-width: 250px;
  }

  &Desktop {
    display: none;
    @include tablet {
      display: inline;
    }
  }

  &Mobile {
    @include tablet {
      display: none;
    }
  }
}

</style>
